module.exports = __webpack_public_path__ + "static/FrankensteinPromo-52-e5517457d5dd647138dac69a0691748b.jpg";